export const EventKeyValues = {
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    SPACE: ' ',
};
